import React from "react";
import PersonalForm from "./PersonalForm";
import BillingForm from "./PaymentForm";
import CompanyForm from "./CompanyForm";
import SectionTitle from "@iso/components/SectionTitle/SectionTitle";
import IntlMessages from "@iso/components/utility/intlMessages";
import { useAuth } from "../../contexts/auth";
import PasswordForm from "./PasswordForm";
import { HasPermission } from "@/helpers/permission";

export default function InformationWrapper() {
  const { partner, user } = useAuth();

  return (
    <div className="grid sm:grid-cols-2 grid-cols-1 gap-5">
      <div>
        <SectionTitle>
          <IntlMessages id="page.myAccount.information.personal.title" />
        </SectionTitle>

        <PersonalForm data={{ ...user, tel: partner.tel }} />
      </div>

      {HasPermission("manage_partner_info") && (
        <div>
          <SectionTitle>
            <IntlMessages id="page.myAccount.information.company.title" />
          </SectionTitle>

          <CompanyForm data={partner} />
        </div>
      )}

      {HasPermission("manage_partner_info") && (
        <div>
          <SectionTitle>
            <IntlMessages id="page.myAccount.information.billing.title" />
          </SectionTitle>
          <BillingForm data={partner} />
        </div>
      )}

      <div>
        <SectionTitle>
          <IntlMessages id="page.myAccount.information.password.title" />
        </SectionTitle>
        <PasswordForm data={user} />
      </div>
    </div>
  );
}
